import { Components, Theme } from '@mui/material/styles';
import IconChervonDown from '~/icons/icon-chevron-down.svg?react';

export default function Select(): Partial<Components<Theme>> {
  return {
    MuiSelect: {
      defaultProps: {
        size: 'small',
        IconComponent: IconChervonDown,
        MenuProps: {
          disablePortal: true,
        },
      },
      styleOverrides: {
        root: {},
        icon: {
          width: 18,
          height: 18,
          marginTop: 3,
          marginRight: 2,
          top: 8,
        },
      },
    },
  };
}
